import React from "react";
import "../../App.css";

function Maria() {
  return (
    <div className="aboutus-container">
      <h1 className="about-us">Maria Violeta Binuya</h1>
        <div class="aboutus-info">
          <div class="row">
            <div class="column">
              <div class="profileimg">
                <img src="images/maria.jpg" alt="Maria"></img>
              </div>
            </div>
            <div class="column">
            <div class="aboutus-offer">
              <p><strong>Master of Education</strong><br></br>
              Course of Study: Assessment and Evaluation<br></br>
              Degree Confirmed: 6th May 1998<br></br>
              Royal Melbourne Institute of Technology University
              <br></br></p>
              <p><strong>Completed Academic Requirement for Doctor of Education</strong><br></br>
              Completed Academic Requirement for Doctor of Education
              </p>
              <p>My proficiency in the Filipino language is excellent for being a native speaker, educated in the Philippines and as a teacher in Filipino language for many years. </p>
              <p>I have been a chief VCE oral assessor in Filipino language for 6 years. I have been a Filipino teacher for many years applying different approach of teaching in the Filipino language. 
              My qualifications are:  
              </p>
              <p class="tab">
              <ul>
                <li>VCE LOTE: Filipino teacher since 1995</li>
                <li>Seasonal  Filipino instructor at DFSL since 1998</li>
                <li>Taught Filipino for Team leader employees of AGL (2013)</li>
                <li>Developed Basic Course in Filipino Curriculum for DFSL</li>
                <li>Developed Basic Course in Filipino Language curriculum for Soccomb LOTE - Cell West in Perth in 2011</li>
                <li>Developed Curriculum for Philippine Language School of Victoria</li>
                <li>Employed to help develop study design for VCAA: LOTE Filipino</li>
                <li>Teach Philippine History and Culture for VCE students as part of curriculum for VCE LOTE Filipino </li>
              </ul>
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Maria;
